<template>
    <div>
        <span v-html="$t('notification.automationUpdated', {user: $_.get(activity, 'actorUser.name'), automation: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "AutomationUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss">
// Basit görünüm - JSON detayları Audit Logs'da gösterilir
</style>
